import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import * as fromLocation from '../location/location.reducer'
import { LocationRoutingModule } from './location-routing.module'
import { LocationEffects } from './location.effects'
import { LocationSerializer } from './location.serializer'
import { LocationService } from './location.service'

@NgModule({
    imports: [
        CommonModule,
        LocationRoutingModule,
        SharedModule,
        StoreModule.forFeature(fromLocation.FEATURE_NAME, fromLocation.locationReducer),
        EffectsModule.forFeature([LocationEffects])
    ],
    declarations: [],
    exports: [],
    providers: [
        LocationService,
        {
            provide: LocationSerializer,
            useClass: LocationSerializer
        }
    ]
})
export class LocationModule {}
